import { Box, Button, Divider, Stack, Typography } from '@mui/material';

import { IcBell } from '@/assets/images';
import { colors } from '@/theme/variables';

import { ModalState } from '../shared/modalState';

type AddToQueueModalContentProps = {
  toggleModal: (modalName: keyof ModalState) => void;
  action: () => void;
};

const AddToQueueModalContent = ({
  toggleModal,
  action,
}: AddToQueueModalContentProps) => {
  return (
    <Box sx={{ maxWidth: 600 }}>
      <Stack
        rowGap={2}
        flex={1}
        alignItems="center"
        fontSize={40}
        padding={5}
        textAlign="center"
      >
        <IcBell width={84} height={84} color={colors.error.main} />
        <Typography component="h3" variant="h6">
          Adding this CFS to the queue will assign it to your unit once all
          current assignments are completed. Do you want to proceed?
        </Typography>
      </Stack>
      <Stack>
        <Divider />
        <Stack direction="row" gap={2} paddingTop={2}>
          <Button
            color="inherit"
            variant="contained"
            size="large"
            sx={{ padding: 2 }}
            fullWidth
            onClick={() => {
              toggleModal('addToQueue');
            }}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            size="large"
            sx={{ padding: 2 }}
            fullWidth
            onClick={() => {
              action();
              toggleModal('addToQueue');
            }}
          >
            Confirm
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AddToQueueModalContent;
